import React, {Component} from "react";
import PropTypes from 'prop-types';
import {Link, Route, Switch} from "react-router-dom";
import LayoutComponent from "../common/LayoutComponent";
import NotFound from "./NotFound";
import NewsItemPreview from "./NewsItemPreview";
import {t} from "../IntManager";

export default class NewsLayout extends Component {
    render() {
        if (this.props.news.notFound) {
            return <Switch>
                <Route component={NotFound}/>
            </Switch>
        }

        let content;
        if (this.props.news.error) {
            content = <div>Не удалось получить данные с сервера</div>
        } else if (this.props.news.loading) {
            content = <div className="preloader">
                <div className="preloader__content relative">
                    <hr/>
                    <hr/>
                    <hr/>
                    <hr/>
                </div>
            </div>
        } else {
            const news = [];
            let i = 0;

            for (let id in this.props.news.items) {
                if (this.props.news.items.hasOwnProperty(id)) {
                    news.push(<NewsItemPreview item={this.props.news.items[id]} left={i % 2 !== 0} key={i}/>);
                    i++;
                }
            }

            content = <div className="row">{news}</div>
        }

        const activeIdx = this.props.activeIdx;
        this.props.setComponentMetaTags && this.props.setComponentMetaTags();

        return <LayoutComponent navReverse routerMatch={this.props.match}>
            <div className="news u-white-background">
                <div className="shell">
                    <header className="section__header">
                        {this.props.header}
                    </header>
                    <ul className="filter-list">
                        <li className={`filter-list__item u-valign-middle ${activeIdx === 0 ? 'is_active' : ''}`}>
                            <Link className="filter-list__link u-overflow-h" to={`/news`}>
                                <span className="menu-item__label relative u-block">{t('all')}</span>
                                <span className="menu-item__label relative u-block">{t('all')}</span>
                            </Link>
                        </li>
                        <li className={`filter-list__item u-valign-middle ${activeIdx === 1 ? 'is_active' : ''}`}>
                            <Link className="filter-list__link u-overflow-h" to={`/news/events`}>
                                <span className="menu-item__label relative u-block">{t('events')}</span>
                                <span className="menu-item__label relative u-block">{t('events')}</span>
                            </Link>
                        </li>
                        <li className={`filter-list__item u-valign-middle ${activeIdx === 2 ? 'is_active' : ''}`}>
                            <Link className="filter-list__link u-overflow-h" to={`/news/stocks`}>
                                <span className="menu-item__label relative u-block">{t('promotions')}</span>
                                <span className="menu-item__label relative u-block">{t('promotions')}</span>
                            </Link>
                        </li>
                    </ul>
                </div>
                <section className="news__section">
                    {content}
                </section>
            </div>
        </LayoutComponent>;
    }
}

NewsLayout.propTypes = {
    news: PropTypes.any,
    match: PropTypes.any,
    header: PropTypes.any,
    activeIdx: PropTypes.number,
    setComponentMetaTags: PropTypes.func,
};


// WEBPACK FOOTER //
// ./src/js/components/NewsLayout.js